import React, { useState, useEffect } from "react";
//import './SREContent.css';
import "./SREContent.css";
import "./PythonContent.css";
import "./AzureContent.css";
import Floaticons from "./Floaticons";
import AzureLearningCards from "./AzureLearningCards";
import AzureLearningJourney from "./AzureLearningJourney";
import { useMsal } from "@azure/msal-react";
import axios from "axios";
function AzureContent() {
 const { instance } = useMsal();
 const [username, setuserName] = useState(null);
 const [isUserPresent, setuserPresent] = useState(true);

 //const baseURL = "http://localhost:3004";
 const baseURL = "https://atci.lkm.accenture.com/shell-university-apis";
 let program = "Azure Data Engineering";
 const activeAccount = instance.getActiveAccount();
 const checkUserPresent = (name) => {
  axios
   .get(`${baseURL}/checkUserActive/${name}`, {
    headers: {
     "Cache-Control": "no-cache",
     Accept: "application/json",
     Pragma: "no-cache",
     Expires: "0",
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   })
   .then((res) => {
    let activeUser = res.data;
    if (activeUser.length != 0) {
     axios
      .get(`${baseURL}/checkNominationList/${name}/${program}`, {
       headers: {
        "Cache-Control": "no-cache",
        Accept: "application/json",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: localStorage.getItem("token"),
        "Content-Type": "application/json",
       },
      })
      .then((res) => {
       let users = res.data;
       users.length != 0 ? setuserPresent(true) : setuserPresent(false);
      })
      .catch((err) => {
       console.log(err);
      });
    } else {
     axios
      .get(`${baseURL}/checkAdminList/${name}`, {
       headers: {
        "Cache-Control": "no-cache",
        Accept: "application/json",
        Pragma: "no-cache",
        Expires: "0",
        Authorization: localStorage.getItem("token"),
        "Content-Type": "application/json",
       },
      })
      .then((res) => {
       console.log("Reponse is", res.data);

       res.data.length != 0 ? setuserPresent(true) : setuserPresent(false);
      })
      .catch((err) => {
       console.log(err);
      });
    }
   })
   .catch((err) => {
    console.log(err);
   });
 };
 useEffect(() => {
  if (activeAccount) {
   setuserName(activeAccount.idTokenClaims.enterpriseID);
   checkUserPresent(activeAccount.idTokenClaims.enterpriseID);
  } else {
   setuserName(null);
  }
 }, [activeAccount.idTokenClaims.enterpriseID]);

 return (
  <>
   <div id="azureSection">
    <div className="main-banner">
     <img src="images/Azure/banner.png" alt="Banner" className="banner-img" />
     <img src="images/Home/banner-strip.png" alt="strip" className="strip-img" />
     <div className="announcemnt-box">
      <p>
       <img src="images/Home/speaker.png" alt="speaker" className="speaker-img" />
       <marquee
        width="92%"
        direction="left"
        style={{ display: "inline-block", verticalAlign: "middle" }}
       >
        {" "}
        <b>Come Join Us</b> on an exhilarating learning Journey on Shell University
        Platform!!!
       </marquee>
      </p>
     </div>
     <Floaticons />
    </div>
    {isUserPresent ? (
     <div className="main-container">
      {/* section 1  */}
      <div className="about-container">
       <div className="about-wrap">
        <h2>About Azure</h2>
        <p>
         Microsoft's Azure is a public cloud computing platform. It provides a broad range
         of cloud services, including compute, analytics, storage and networking. Users
         can pick and choose from these services to develop and scale new applications or
         run existing applications in the public cloud. The Azure cloud platform is more
         than 200 products and cloud services designed to help you bring new solutions to
         life—to solve today’s challenges and create the future.{" "}
        </p>
       </div>
      </div>
      {/* section 2  */}
      <div className="program-container">
       <div className="program-wrap">
        <h2>Program Objectives</h2>
        <ul>
         <li>
          This program is intended for resources to enable them with the required
          knowledge on Azure Cloud PaaS and Azure Data Services{" "}
         </li>
         <li>
          To develop a knowledgeable Azure Cloud workforce and guarantee cloud-based
          solutions for clients.
         </li>
        </ul>
       </div>
      </div>
      <AzureLearningJourney />
      <div className="external-certification-container">
       <h5>External Certifications</h5>
       <p>
        Complete your learning journey and earn accredited external certification in the
        area of your expertise which can help in advancing your career.
       </p>
       <div className="ex-wrapper">
        <div className="ex-box">
         <img src="images/Azure/certifications/AZ-900.png" alt="certification-icon" />
         <span>AZ-900: Microsoft Azure Fundamentals</span>
        </div>
        <div className="ex-box">
         <img src="images/Azure/certifications/AZ-204.png" alt="certification-icon" />
         <span>AZ-204: Microsoft Azure Developer Associate</span>
        </div>
        <div className="ex-box">
         <img src="images/Azure/certifications/DP-203.png" alt="certification-icon" />
         <span>DP-203: Data Engineering on Microsoft Azure</span>
        </div>
       </div>
      </div>
      <AzureLearningCards />
      <br />
      {/* section 4  */}
      <div className="features-container">
       <h2>Program Highlights</h2>
       <div className="features-wrap">
        <div className="features-row">
         <img
          src="images/SRE/feature-icon1.png"
          alt="feature-icon"
          className="feature-icon"
         />
         <p>Self-paced Learning</p>
        </div>
        <div className="features-row">
         <img
          src="images/SRE/feature-icon2.png"
          alt="feature-icon"
          className="feature-icon"
         />
         <p>SME Connects</p>
        </div>
        <div className="features-row">
         <img
          src="images/SRE/feature-icon3.png"
          alt="feature-icon"
          className="feature-icon"
         />
         <p>Final Assessment</p>
        </div>
        <div className="features-row">
         <img
          src="images/SRE/feature-icon4.png"
          alt="feature-icon"
          className="feature-icon"
         />
         <p>Earn Completion Certificates, Flair, R&R</p>
        </div>
        <div className="features-row">
         <img
          src="images/SRE/feature-icon6.png"
          alt="feature-icon"
          className="feature-icon"
         />
         <p>End-to-End case studies</p>
        </div>
       </div>
      </div>
     </div>
    ) : (
     <div className="alter-conatiner">
      <p>
       You are not enrolled to this learning program. Please contact &nbsp;
       <a
        onClick={() => {
         window.open("mailto:LKM.ABCUniversity@accenture.com");
        }}
        href=""
       >
        LKM.ABCUniversity@accenture.com
       </a>
       &nbsp; for any queries regarding the program.
      </p>
     </div>
    )}
   </div>
  </>
 );
}

export default AzureContent;
